import {AuctionsManager, DataStore} from "@nextlot/core/webcast";
import {useTranslation} from "react-i18next";
import {ParticipantRolesEnum} from "@nextlot/core/webcast/services/AuctionsManager";
import BidderLanguageSelectorCmp from "./BidderLanguageSelectorCmp";
import { TaggedLogger } from "@nextlot/core/utilities";

const _logger = TaggedLogger.get('BidderPageHeaderCmp');


export default function BidderPageHeaderCmp(props) {
    const { t, i18n } = useTranslation();

    return (
        <div className="bidder-page-header-container">
            <div className="position-relative header__center-container">

                <div className="header__logo-container">
                    <img src={DataStore.config.site_logo_image_url} alt="Logo" />
                </div>

                <div className="header__main-container">
                    <div className="title-wrapper">
                        <h5 className="title">{AuctionsManager.currentWebcastAuctionHandler.auctionConnectData.auctionName}</h5>
                    </div>
                    <div className="subtitle">
                        <span className="me-3">
                          {'\u260F'} <span className="d-none d-sm-inline">{t('pageHeader.techSupport')}:</span> {DataStore.config.site_tech_support_phone}
                        </span>
                        <span>
                          {'\u260F'} <span className="d-none d-sm-inline">{t('pageHeader.auctionCompany')}:</span> {DataStore.config.site_support_phone}
                        </span>
                    </div>
                </div>

                <div className="header__right-container">

                    <div className="position-absolute top-0 end-0 hstack gap-1 pt-md-4">
                      <div className="catalog-link-wrapper">
                          <a href={`${location.origin}/auctions/${AuctionsManager.currentWebcastAuctionHandler.auctionConnectData.auctionId}/lots`} target="_blank" rel="noopener noreferrer" className="btn btn-sm catalog-link">{t('pageHeader.fullCatalog')}</a>
                      </div>

                      <BidderLanguageSelectorCmp/>
                    </div>


                    <div className="welcome-message">
                      {t('pageHeader.welcome')},
                      <strong className="ps-1">
                          {
                              AuctionsManager.currentWebcastAuctionHandler.auctionConnectData.participantRole === ParticipantRolesEnum.bidder
                                  ? <>{t('pageHeader.bidder')}&nbsp;#&nbsp;</>
                                  : <>{t('pageHeader.viewer')}&nbsp;</>
                          }
                          <>
                            {AuctionsManager.currentWebcastAuctionHandler.auctionConnectData.bidderNumber}
                            &nbsp;({AuctionsManager.currentWebcastAuctionHandler.auctionConnectData.bidderLabel})
                          </>
                      </strong>
                    </div>



                </div>


            </div>
        </div>
    )
}



// class BidderPageHeaderCmp extends React.Component {
//
//     constructor(props) {
//         super(props);
//
//         this.auctionConnectData = AuctionsManager.currentWebcastAuctionHandler.auctionConnectData;
//     }
//
//
//
//     handleClick_ViewFullCatalog = (event) => {
//         event.preventDefault();
//
//         this.popupFullCatalog = window.open(this.saleConnectData.popupViewCatalogUrl, 'webcast_view_catalog_' + this.saleConnectData.auctionId,
//             'toolbar=0,resizable=1,directories=0,status=0,menubar=0,scrollbars=0,width=700,height=' + screen.availHeight + ',top=4');
//         if (!this.popupFullCatalog) {
//             alert('Please disable your pop-up blocker and click the "View Full Catalog" button again again.');
//         } else {
//             this.popupFullCatalog.focus();
//         }
//     };
//
//
//
//     render() {
//         const { t } = this.props;
//
//         return (
//             <div className="bidder-page-header-container">
//                 <div className="header__center-container">
//
//                     <div className="header__logo-container">
//                         <img src={DataStore.config.siteLogoImageUrl} alt="Logo" />
//                     </div>
//
//                     <div className="header__main-container">
//                         <div className="title-wrapper">
//                             <h5 className="title">{this.saleConnectData.auctionName}</h5>
//                         </div>
//                         <div className="subtitle">
//                             {'\u260F'} {t('pageHeader.techSupport')}: {DataStore.config.sitePhoneTechSupport}
//                             &nbsp; &nbsp;
//                             {'\u260F'} {t('pageHeader.auctionCompany')}: {DataStore.config.sitePhoneAuctionCompany}
//                         </div>
//                     </div>
//
//                     <div className="header__right-container">
//
//                         <div className="welcome-message">{t('pageHeader.welcome')}, <strong>{this.saleConnectData.userRole === 'bidder' ? `${t('pageHeader.bidder')}` : `${t('pageHeader.viewer')}`} {this.saleConnectData.bidderNo} ({this.saleConnectData.bidderLabel})</strong></div>
//
//                         <div className="catalog-link-wrapper">
//                             <a href="#" target="_blank" rel="noopener noreferrer" className="btn catalog-link" onClick={this.handleClick_ViewFullCatalog}>{t('pageHeader.fullCatalog')}</a>
//                         </div>
//                     </div>
//
//
//                 </div>
//             </div>
//         )
//     }
//
// }

// export default withTranslation()(BidderPageHeaderCmp);
